export default "__VITE_ASSET__4e6c19a9__"